import React, { SetStateAction, useState } from 'react';
import { Button } from 'react-bootstrap';
import { Pen, Trash } from 'react-bootstrap-icons';
import { UseFormReset } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import ConfirmationModal from '../../../shared/components/ConfirmationModal';
import { handleError } from '../../../shared/functions/handleError';
import { IUser } from '../../../shared/interfaces/IUser';
import { AdminUserService } from '../service';

interface IProps {
  users: IUser[];
  isAdmin?: boolean;
  reset: UseFormReset<IUser>;
  setIsActionModalOpened: React.Dispatch<SetStateAction<boolean>>;
  handleUpdateList: () => void;
}
const UserTable = ({
  users,
  reset,
  isAdmin,
  setIsActionModalOpened,
  handleUpdateList,
}: IProps) => {
  const { t } = useTranslation();
  const [isDeleteOpened, setIsDeleteOpened] = useState(false);
  const [selectedUser, setSelectedUser] = useState<IUser | undefined>(
    undefined,
  );
  const handleCancelDelete = () => {
    setSelectedUser(undefined);
    setIsDeleteOpened(false);
  };
  const handleConfirmDelete = async () => {
    !!selectedUser?.id &&
      (await AdminUserService.delete(selectedUser?.id)
        .then((response) => {
          if (response) {
            handleUpdateList();
            handleCancelDelete();
            toast.success(
              t('toast.successDelete', { name: selectedUser?.displayName }),
            );
          }
        })
        .catch(handleError));
  };
  return (
    <>
      <div className="table-responsive">
        <table className="table ">
          <thead className="table-dark">
            <tr>
              <th scope="col">#</th>
              <th scope="col">{t('general.displayName')}</th>
              <th scope="col">{t('general.email')}</th>
              <th scope="col">{t('general.country')}</th>
              <th scope="col">{t('general.phoneNumber')}</th>
              {isAdmin && <th scope="col">{t('general.actions')}</th>}
            </tr>
          </thead>
          <tbody className={'border'}>
            {users?.map((user) => {
              return (
                <tr key={user?.id}>
                  <td>{user?.id}</td>
                  <td>{user?.displayName}</td>
                  <td>{user?.email}</td>
                  <td>{t(`country.${user?.country}`)}</td>
                  <td>{user?.phoneNumber}</td>
                  {isAdmin && (
                    <td>
                      <Button
                        variant={'warning'}
                        size={'sm'}
                        onClick={() => {
                          reset(user);
                          setIsActionModalOpened(true);
                        }}
                      >
                        <Pen />
                      </Button>
                      {isAdmin && (
                        <Button
                          variant={'danger'}
                          className={'ms-2'}
                          size={'sm'}
                          onClick={() => {
                            setSelectedUser(user);
                            setIsDeleteOpened(true);
                          }}
                        >
                          <Trash />
                        </Button>
                      )}
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <ConfirmationModal
        name={selectedUser?.displayName}
        isActionModalOpened={isDeleteOpened}
        handleConfirmDeletion={handleConfirmDelete}
        handleCloseActionModal={handleCancelDelete}
      />
    </>
  );
};

export default UserTable;
